export default function Video(props) {
	const {fileId, videoSrc} = props;
	return (<video width="100%" id="ourvideo" controls>
		<source id={fileId} src={videoSrc} />
	</video>);
}
